"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLog = exports.UserRequestLogFetchRequest = exports.UserRequestLog = exports.UserLogType = exports.NotificationTopicType = exports.NotificationChannelType = void 0;
var NotificationChannelType;
(function (NotificationChannelType) {
    NotificationChannelType["notification"] = "notification";
    NotificationChannelType["email"] = "email";
    NotificationChannelType["sms"] = "sms";
    NotificationChannelType["browserpush"] = "browserpush";
})(NotificationChannelType = exports.NotificationChannelType || (exports.NotificationChannelType = {}));
var NotificationTopicType;
(function (NotificationTopicType) {
    NotificationTopicType["approved_company"] = "approved-company";
    NotificationTopicType["chat_message_in_thread"] = "chat-message-in-thread";
    NotificationTopicType["new_company"] = "new-company";
    NotificationTopicType["new_order_file"] = "new-order-file";
    NotificationTopicType["password_recovery"] = "password-recovery";
    NotificationTopicType["quotation_created_in_thread"] = "quotation-created-in-thread";
    NotificationTopicType["quotation_terms_accepted"] = "quotation-terms-accepted";
    NotificationTopicType["quotation_updated"] = "quotation-updated";
    NotificationTopicType["registered_company"] = "registered-company";
    NotificationTopicType["rejected_thread"] = "rejected-thread";
    NotificationTopicType["rfq_added_to_listing"] = "rfq-added-to-listing";
    NotificationTopicType["rfq_updated"] = "rfq-updated";
    NotificationTopicType["system_message"] = "system-message";
    NotificationTopicType["user_disabled"] = "user-disabled";
})(NotificationTopicType = exports.NotificationTopicType || (exports.NotificationTopicType = {}));
var UserLogType;
(function (UserLogType) {
    UserLogType["REQ"] = "REQ";
    UserLogType["NLG"] = "NLG";
    UserLogType["EML"] = "EML";
    UserLogType["SMS"] = "SMS";
})(UserLogType = exports.UserLogType || (exports.UserLogType = {}));
class UserRequestLog {
}
exports.UserRequestLog = UserRequestLog;
class UserRequestLogFetchRequest {
}
exports.UserRequestLogFetchRequest = UserRequestLogFetchRequest;
class NotificationLog {
}
exports.NotificationLog = NotificationLog;
